import { useLocation, useNavigate } from "react-router-dom";
import useDeviceType from "../../hook/useDeviceType";
import useCheckLogin from "../../hook/useCheckLogin";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { notice } from "../../redux/action/action";
import { useCallback } from "react";

const useGames = ({ customPreviousPage = null } = {}) => {
  const { t } = useTranslation();

  const isMobile = useDeviceType() === "Mobile";
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();

  const { isLogin } = useCheckLogin();

  const handlePlayGame = useCallback(
    ({ gameName, gamePlatform, gameUid, directToGameBox = false }) => {
      if (!isLogin) {
        dispatch(
          notice({
            title: t("common.Please login first"),
            type: "error",
          }),
        );
        navigate("signin", {
          state: {
            previousLocation: location,
          },
        });
        return;
      }
      if (directToGameBox) {
        navigate(`/gamebox/${gameName}/${gamePlatform}/${gameUid}`, {
          state: {
            previousLocation: location,
          },
        });
        return;
      }

      if (isMobile) {
        if (location.pathname.includes("/game-confirm")) {
          navigate(`../game-confirm/${gameName}/${gamePlatform}/${gameUid}`);
          return;
        }
        navigate(`game-confirm/${gameName}/${gamePlatform}/${gameUid}`);
      } else {
        const inGamebox = location.pathname.includes("/gamebox");

        navigate(`/gamebox/${gameName}/${gamePlatform}/${gameUid}`, {
          state: {
            previousLocation: inGamebox
              ? location.state?.previousLocation
              : location,
          },
        });
      }
    },
    [isLogin, isMobile, location, navigate, dispatch, t],
  );
  const previousPage =
    location.state?.previousLocation?.pathname || customPreviousPage || -1;

  const handleExitGame = () => {
    navigate(previousPage);
  };

  return {
    handlePlayGame,
    handleExitGame,
    previousPage,
  };
};

export default useGames;
